import {
    /** FETCH APPLICATION  */
    FETCH_APPLICATIONDETAIL_FULFILLED,
    FETCH_APPLICATIONDETAIL_REJECTED,
    FETCH_APPLICATIONDETAIL_PENDING,
    RESET_APPLICATIONDETAIL
} from "../../actions/v3/applicationDetail";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_APPLICATIONDETAIL_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_APPLICATIONDETAIL_FULFILLED:
            return {
                ...state,
                applicationDetail: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_APPLICATIONDETAIL_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_APPLICATIONDETAIL:
            return {
                initialState,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};